<template>
  <b-jumbotron v-if="image_selected">
    <template v-slot:lead>
      Adjust your image until the desired crop area fits within the box.
    </template>
    <div class="crop-container">
      <div class="overlay" v-bind:style="{ height: overlay_height }"></div>
      <!-- This image must be on the same domain as the demo or it will not work on a local file system -->
      <!-- http://en.wikipedia.org/wiki/Cross-origin_resource_sharing -->
      <b-img class="resize-image" :src="src" alt="image for resizing" fluid />
    </div>
    <hr />
    <b-button-toolbar>
      <b-button-group class="mx-1">
        <b-button variant="primary" @click.prevent="crop">
          Crop
        </b-button>
        <b-button variant="danger" @click.prevent="clearFile">Cancel</b-button>
        <b-button v-if="altered" variant="warning" @click.prevent="resetImage"
          >Reset</b-button
        >
        <b-button v-if="cropped" variant="success" @click.prevent="confirm"
          >Confirm</b-button
        >
      </b-button-group>
    </b-button-toolbar>
  </b-jumbotron>
  <div v-else>
    <!-- Styled -->
    <b-form-file
      class="image-editor-input"
      v-model="file"
      :state="Boolean(file)"
      :placeholder="placeholder"
      drop-placeholder="Drop file here..."
      browse-text="Edit"
      accept="image/*"
      @input="checkForFile"
    ></b-form-file>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerImage: null,
      orig_src: new Image(),
      image_selector: ".resize-image",
      file: null,
      src: "",
      altered: false,
      cropped: false,
      image_target: null,
      image_selected: false,
      container: null,
      event_state: {},
      constrain: true,
      min_width: 180,
      overlay_height: ""
    };
  },
  props: { aspect: Number, placeholder: String },
  computed: {
    min_height() {
      return this.min_width / this.aspect;
    },
    max_width() {
      return 2 * $(".overlay").width();
    },
    max_height() {
      return this.max_width / this.aspect;
    },
    image() {
      return $(this.image_selector);
    },
    img_too_wide() {
      return this.image.width() > this.max_width;
    },
    img_too_tall() {
      return this.image.height() > this.max_height;
    },
    img_too_thin() {
      return this.image.width() < this.min_width;
    },
    img_too_short() {
      return this.image.height() < this.min_height;
    }
  },
  methods: {
    onResize() {
      this.overlay_height = `${$(".overlay").width() / this.aspect}px`;
    },
    adjustImage() {
      if (this.img_too_wide) {
        this.resizeImage(
          this.max_width,
          this.image.height() / (this.image.width() / this.max_height)
        );
      }
    },
    clearFile() {
      this.file = null;
      this.checkForFile();
      this.$emit("croppingCancelled");
    },
    resetImage() {
      this.src = URL.createObjectURL(this.file);
      this.altered = false;
      if (this.cropped) {
        $(".resize-container").show();
        $(".overlay").css("background-image", "");
      }
      this.cropped = false;
    },
    checkForFile() {
      var vm = this;
      this.image_selected = Boolean(this.file);
      if (this.image_selected) {
        this.$emit("cropping");
        this.onResize();
        this.src = URL.createObjectURL(this.file);
        this.$nextTick().then(function() {
          vm.init();
          vm.onResize();
        });
      }
    },
    init: function() {
      this.image_target = $(this.image_selector);
      // When resizing, we will always use this copy of the original as the base
      this.orig_src.src = $(this.image_selector).attr("src");
      // Wrap the image with the container and add resize handles
      $(this.image_selector)
        .wrap('<div class="resize-container"></div>')
        .before('<span class="resize-handle resize-handle-nw"></span>')
        .before('<span class="resize-handle resize-handle-ne"></span>')
        .after('<span class="resize-handle resize-handle-se"></span>')
        .after('<span class="resize-handle resize-handle-sw"></span>');

      // Assign the container to a variable
      this.container = $(this.image_selector).parent(".resize-container");

      // Add events
      this.container.on(
        "mousedown touchstart",
        ".resize-handle",
        this.startResize
      );
      var vm = this;
      this.container.on("mousedown touchstart", "img", this.startMoving);
    },
    startResize: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.saveEventState(e);
      $(document).on("mousemove", this.resizing);
      $(document).on("mouseup", this.endResize);
    },

    endResize: function(e) {
      e.preventDefault();
      $(document).off("mouseup touchend", this.endResize);
      $(document).off("mousemove touchmove", this.resizing);
    },
    saveEventState: function(e) {
      // Save the initial event details and container state
      this.event_state.container_width = this.container.width();
      this.event_state.container_height = this.container.height();
      this.event_state.container_left = this.container.offset().left;
      this.event_state.container_top = this.container.offset().top;
      this.event_state.mouse_x =
        (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) +
        $(window).scrollLeft();
      this.event_state.mouse_y =
        (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) +
        $(window).scrollTop();

      // This is a fix for mobile safari
      // For some reason it does not allow a direct copy of the touches property
      if (typeof e.originalEvent.touches !== "undefined") {
        this.event_state.touches = [];
        $.each(e.originalEvent.touches, function(i, ob) {
          this.event_state.touches[i] = {};
          this.event_state.touches[i].clientX = 0 + ob.clientX;
          this.event_state.touches[i].clientY = 0 + ob.clientY;
        });
      }
      this.event_state.evnt = e;
    },
    resizing: function(e) {
      var mouse = {},
        width,
        height,
        left,
        top,
        offset = this.container.offset();
      mouse.x =
        (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) +
        $(window).scrollLeft();
      mouse.y =
        (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) +
        $(window).scrollTop();

      width = mouse.x - this.event_state.container_left;
      height = mouse.y - this.event_state.container_top;
      left = this.event_state.container_left;
      top = this.event_state.container_top;

      if (this.constrain || e.shiftKey) {
        height = (width / this.orig_src.width) * this.orig_src.height;
      }

      // if (
      //   width > this.min_width &&
      //   height > this.min_height &&
      //   width < this.max_width &&
      //   height < this.max_height
      // ) {
      this.resizeImage(width, height);
      // Without this Firefox will not re-calculate the the image dimensions until drag end
      this.container.offset({ left: left, top: top });
      // }
    },
    resizeImage: function(width, height) {
      var resize_canvas = document.createElement("canvas");
      resize_canvas.width = width;
      resize_canvas.height = height;
      resize_canvas
        .getContext("2d")
        .drawImage(this.orig_src, 0, 0, width, height);
      this.src = resize_canvas.toDataURL("image/png");
      this.altered = true;
    },
    startMoving: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.saveEventState(e);
      $(document).on("mousemove", this.moving);
      $(document).on("mouseup", this.endMoving);
    },

    endMoving: function(e) {
      e.preventDefault();
      $(document).off("mouseup", this.endMoving);
      $(document).off("mousemove", this.moving);
    },
    moving: function(e) {
      var mouse = {};
      e.preventDefault();
      e.stopPropagation();
      mouse.x = (e.clientX || e.pageX) + $(window).scrollLeft();
      mouse.y = (e.clientY || e.pageY) + $(window).scrollTop();
      this.container.offset({
        left:
          mouse.x -
          (this.event_state.mouse_x - this.event_state.container_left),
        top:
          mouse.y - (this.event_state.mouse_y - this.event_state.container_top)
      });
    },
    crop: function() {
      if (!this.altered)
        this.resizeImage(
          this.image_target.get(0).width,
          this.image_target.get(0).height
        );

      var crop_canvas,
        left = $(".overlay").offset().left - this.container.offset().left,
        top = $(".overlay").offset().top - this.container.offset().top,
        width = $(".overlay").width(),
        height = $(".overlay").height();

      crop_canvas = document.createElement("canvas");
      crop_canvas.width = width;
      crop_canvas.height = height;
      const vm = this;
      this.$nextTick().then(function() {
        crop_canvas
          .getContext("2d")
          .drawImage(
            $(vm.image_selector).get(0),
            left,
            top,
            width,
            height,
            0,
            0,
            width,
            height
          );
        $(".resize-container").hide();
        vm.src = crop_canvas.toDataURL("image/png");

        $(".overlay").css(
          "background-image",
          'url("' + crop_canvas.toDataURL("image/png") + '")'
        );
      });

      this.cropped = true;
      this.altered = true;
      // var iframe =
      //   "<iframe width='100%' height='100%' src='" +
      //   crop_canvas.toDataURL("image/png") +
      //   "'></iframe>";
      // var x = window.open();
      // x.document.open();
      // x.document.write(iframe);
      // x.document.close();
      // window.open(crop_canvas.toDataURL("image/png"), "_blank");
    },
    confirm() {
      this.$emit("cropped", $(this.image_selector).attr("src"));
      this.reset;
      this.clearFile();
    }
  },
  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style>
.crop-container {
  overflow: hidden;
}

.resize-container {
  position: relative;
  display: inline-block;
  cursor: move;
  margin: 0 auto;
}

.resize-container img {
  display: block;
}

.resize-container:hover img,
.resize-container:active img {
  outline: 2px dashed rgba(222, 60, 80, 0.9);
}

.resize-handle-ne,
.resize-handle-se,
.resize-handle-nw,
.resize-handle-sw {
  position: absolute;
  display: block;
  width: 10px;
  height: 10px;
  background: rgba(222, 60, 80, 0.9);
  z-index: 999;
}

.resize-handle-nw {
  top: -5px;
  left: -5px;
  cursor: nw-resize;
}

.resize-handle-sw {
  bottom: -5px;
  left: -5px;
  cursor: sw-resize;
}

.resize-handle-ne {
  top: -5px;
  right: -5px;
  cursor: ne-resize;
}

.resize-handle-se {
  bottom: -5px;
  right: -5px;
  cursor: se-resize;
}

.overlay {
  position: relative;
  z-index: 999;
  height: 200px;
  border: solid 2px rgba(222, 60, 80, 0.9);
  box-sizing: content-box;
  pointer-events: none;
}

.overlay:before {
  top: 0;
  margin-left: -2px;
  margin-top: -40px;
}

.overlay:after {
  bottom: 0;
  margin-left: -2px;
  margin-bottom: -40px;
}

.btn-crop {
  position: relative;
  vertical-align: bottom;
  right: 5px;
  bottom: 5px;
  padding: 6px 10px;
  z-index: 999;
  background-color: rgb(222, 60, 80);
  border: none;
  border-radius: 5px;
  color: #fff;
}

.btn-crop img {
  vertical-align: middle;
  margin-left: 8px;
}
.image-editor-input label {
  font-size: 1rem !important;
  font-weight: 100 !important;
}
</style>
